<script setup>
import { Icon } from "@iconify/vue";
import Select from "@iconify-icons/ep/select";
</script>

<template>
  <Icon :icon="Select" />
</template>
